// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ShZPk","noPaddingTop":"styles_noPaddingTop__TAhr4","noPaddingBottom":"styles_noPaddingBottom__2CSih"};